import {Page} from "../js/page";
import {GvfService} from "../../gvf/js/gvf-service";
import {UtilsService} from "../js/utils-service";

export class LoginPage extends Page{
    constructor(scope,$root){
        super(scope,$root);
    }
    
    ready(){
        this.$root.find(".js-google-authenticator__logout").click(
            (ev) => {
                ev.preventDefault();
                $(ev.currentTarget).addClass("is-loading");
                GvfService.endpoint(
                    "/cp/google-authenticator/delete-session",
                    {}
                ).then(
                    (response)=>{
                        console.log(response);
                        window.location = "/";
                    }
                ).catch(
                    (response)=>{
                        UtilsService.alertEndpointResponse(response);
                    }
                ).finally(
                    ()=>{
                        $(ev.currentTarget).removeClass("is-loading");
                    }
                );
            }
        );

        if(this.$root.data("popup-message")){
            swal(
                {
                    type: "info",
                    title: "",
                    text: this.$root.data("popup-message")
                }
            );
        }

        this.$loginForm = this.findMember("login-form");
        this.$recoverForm = this.findMember("recover-form");
        this.findMember("recover-link").click(
            (ev)=>{
                ev.preventDefault();
                this.$recoverForm.find("[name=email]").val(this.$loginForm.find("[name=email]").val());
                this.$loginForm.slideUp(
                    ()=>{
                        this.$recoverForm.slideDown();
                    }
                );
            }
        );

        this.$loginForm.submit(
            (ev)=>{
                if(!this.$loginForm.data("restrictionsOk")){
                    ev.preventDefault();
                    this.$loginForm.checkRestrictions().then(
                        (isOk) => {
                            if(isOk){
                                this.$loginForm.data("restrictionsOk",true);
                                this.$loginForm.submit();
                            }
                        }
                    );
                }
            }
        );

        this.$recoverForm.submit(
            (ev)=>{
                ev.preventDefault();
                const $button = this.$recoverForm.find(this.scope+"__recover-button");
                $button.prop("disabled",true);
                GvfService.endpoint(
                    "/cp/login/reset-pass-request",
                    {data:this.$recoverForm.getValues()}
                ).then(UtilsService.alertEndpointResponse)
                .catch(UtilsService.alertEndpointResponse)
                .finally(
                    ()=>{
                        $button.prop("disabled",false);
                    }
                );
            }
        );

        this.findMember("recover-cancel-button").click(
            (ev)=>{
                ev.preventDefault();
                this.$recoverForm.slideUp(
                    ()=>{
                        this.$loginForm.slideDown();
                    }
                );
            }
        );

        this.findMember("get-subscription-plans-button").click(
            (ev)=> {
                ev.preventDefault();
                const subscriptionPlanType = $(ev.currentTarget).data("subscription-plan-type");
                GvfService.endpoint(
                    "/cp/login/get-subscription-plans-url",
                    {subscriptionPlanType: subscriptionPlanType}
                ).then((resp) => {
                        window.location.href = resp;
                    }
                ).catch(UtilsService.alertEndpointResponse);
            }
        );

        this.findMember("go-login-button").click(
            (ev)=> {
                ev.preventDefault();
                window.location.href = "/";
            }
        );

        const plans = document.querySelectorAll('.js-login-page__plan');
        const selectButton = this.findMember("select-subscription-plan-button");

        plans.forEach(plan => {
            plan.addEventListener('click', function() {
                plans.forEach(p => p.classList.remove('selected'));
                this.classList.add('selected');
                selectButton.prop("disabled", false);
            });
        });

        selectButton.click((ev) => {
            ev.preventDefault();
            const selectedPlan = document.querySelector('.cp-register-page__plan.selected');

            const selectedPlanId = selectedPlan.getAttribute('data-subscription-plan-id');
            const supplierSubscriptionCode = selectedPlan.getAttribute('data-supplier-subscription-code');
            GvfService.endpoint(
                "/cp/login/get-subscription-plans-url",
                {supplierSubscriptionCode: supplierSubscriptionCode, subscriptionPlanId: selectedPlanId}
            ).then((resp) => {
                    window.location.href = resp;
                }
            ).catch(UtilsService.alertEndpointResponse);
        });

        selectButton.prop("disabled", true);

        this.findMember("lang-input").click((ev)=>{
            ev.preventDefault();
            localStorage.setItem('lang', $(ev.currentTarget).data('lang'));
            this.findMember('lang-input').each((index, item)=>{
                if($(item)!=$(ev.currentTarget)){
                    $(item).removeClass('is-active');
                }
            });
            if(!$(ev.currentTarget).hasClass('is-active')){
                $(ev.currentTarget).addClass('is-active');
            }
            GvfService.endpoint("/cp/login/change-lang",{lang: $(ev.currentTarget).data('lang') }).then((resp) => {
                window.location.reload();
            }).catch(UtilsService.alertEndpointResponse);
        });
        let lang = localStorage.getItem('lang');
        if(lang){
            this.findMember('lang-input').each((index, item)=>{
                if($(item).data('lang')===lang){
                    $(item).addClass('is-active');
                } else {
                    $(item).removeClass('is-active');
                }
            });
        }

        $(document).on('click', '.password-toggle', function() {
            let $input = $(this).closest('.input-group').find('input[data-password-toggle]');
            let $icon = $(this).find('i');
            if ($input.length) {
                if ($input.attr('type') === 'password') {
                    $input.attr('type', 'text');
                    $icon.removeClass('mdi-eye-off').addClass('mdi-eye');
                } else {
                    $input.attr('type', 'password');
                    $icon.removeClass('mdi-eye').addClass('mdi-eye-off');
                }
            }
        });
    }
}

